/**
 * Text areas that get harper.js spell & grammar checking.
 *
 * Form schemas are served by the schema service, so fields are enabled here without
 * a schema upload, matched by label or by the end of their model path (`$id`).
 * A schema can also opt in any TextArea with `spellCheck: true`.
 */
export const SPELLCHECK_FIELD_LABELS = [
  'pq description',
  'sender comments',
  'additional comment',
  'additional comments'
];

// For fields without a usable label, e.g. AE description's TextArea is unlabelled
export const SPELLCHECK_FIELD_PATHS = [
  'adverseEvent.reactions.description[0].value',
  'adverseEvent.reactions.description.0.value',
  'sender_comments',
  'pqComment'
];

const normalizeLabel = label =>
  typeof label === 'string'
    ? label
        .replace(/[:*]/g, '')
        .trim()
        .toLowerCase()
    : '';

const matchesPath = $id =>
  typeof $id === 'string' &&
  SPELLCHECK_FIELD_PATHS.some(path => $id === path || $id.endsWith(`.${path}`));

export const isSpellCheckField = ({ spellCheck, label, $id }) =>
  spellCheck === true ||
  SPELLCHECK_FIELD_LABELS.includes(normalizeLabel(label)) ||
  matchesPath($id);
